module.exports = __webpack_public_path__ + "img/del_SDcard_data-en-US.64da2645.png";